import { RootState } from '../../store/root-state';
import { ActionCenterPrefill } from './action-center-prefill';

/** The pending prefill, if it is for `documentId`. */
export const getActionCenterPrefill =
  (documentId: string | undefined) =>
  (state: RootState): ActionCenterPrefill | null =>
    documentId && state.actionCenterPrefill?.documentId === documentId
      ? state.actionCenterPrefill
      : null;
